<template>
    <div class="grid" v-if="getMovil() == null || getParada() == null">
		<div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-2">
			<Message severity="error" class="p-col-12">
				Para poder operar en el sistema debe seleccionar el comedor y parada donde está cumpliendo funciones.
			</Message>
		</div>
	</div>
	<div class="grid" v-if="getMovil() != null && getParada() != null">
		<div class="col-12 md:col-6 xl:col-3">
			<div class="card grid-nogutter widget-overview-box widget-overview-box-1">
				<span class="overview-icon">
					<i class="pi pi-exclamation-circle"></i>
				</span>
				<span class="overview-title">Registro de entrega excepcional</span>
				<div class="grid overview-detail">
					<div class="col-12">
						<div class="overview-subtext">En caso de realizar entrega de alimentos sin leer código QR o ingresar código alfanumérico, registre el motivo y la cantidad a entregar así como una observación complementaria de la entrega.</div>
					</div>
				</div>
			</div>
		</div>

		<div class="grid p-mt-5">
			<div class="col-12">
				<div class="card">
                    <Toast/>
                    <Message class="p-col-12">
                        Usted está operando en:<br>
                        <i class="pi pi-map"/> {{getMovilName()}}<br>
                        <i class="pi pi-map-marker"/> <i>{{getParadaName()}}</i>
                    </Message>
                    <div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-2">
                        <div class="p-field p-col-12 p-md-6">
                            <label for="motivos">Motivo de entrega excepcional</label>
                            <Dropdown id="motivos" v-model="motivo" :options="motivos" optionLabel="MEExcNombre" optionValue="MEExcId" placeholder="Seleccionar" 
                            autofocus :class="{'p-invalid': submittedMotivo && !motivo}" :loading="loadingmotivo"/>
                            <small class="p-invalid" v-if="submittedMotivo && !motivo">Se requiere seleccionar un motivo de entrega.</small>
                        </div>
                        <div class="p-field p-col-12 p-md-6">
                            <label for="motivos">Cantidad entregada</label>
                            <InputNumber v-model="cantidad" mode="decimal" :min="1" :max="100" showButtons inputId="horizontal-buttons" buttonLayout="horizontal" :step="1" readonly="true"/>
                        </div>
                        <div class="p-field p-col-12 p-md-12">
                            <label for="obs">Observación</label>
                            <Textarea id="obs" v-model="observacion" :class="{'p-invalid': (submittedObs && !observacion) || (submittedObs && observacion.length > 150)}" :autoResize="true" v-on:keydown.enter.prevent/>
                            <small class="p-invalid" v-if="submittedObs && !observacion">Se requiere una aclaración en relación a la entrega excepcional realizada.</small>
                            <small class="p-invalid" v-if="submittedObs && observacion && observacion.length > 150">El largo del texto no puede superar los 150 caracteres.</small>
                        </div>
                    </div>
                    <Toolbar>
                        <template v-slot:left>
                            <Button label="Limpiar" @click="clearAll()" icon="pi pi-eraser" iconPos="left" class="p-button-secondary mr-2 mb-2"/>
                        </template>

                        <template v-slot:right>
                            <Button label="Entregar" @click="entregar()" icon="pi pi-angle-right" iconPos="left" :loading="loading"/>
                        </template>
                    </Toolbar>
				</div> 
			</div>
		</div>
	</div>	

	<Dialog header="Aguarde..." v-model:visible="wait" :style="{width: '150px'}" :modal="true" :position="left">
		<div align="center">
			<ProgressSpinner style="width:50px;height:50px" strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"/>
		</div>
	</Dialog>
	
</template>

<script>
import SmartService from '../service/SmartService';
export default {
	data() {
		return {
			wait: false,
            loading: false,
            motivo: null,
            cantidad: 1,
            observacion: null,
            submittedMotivo: false,
            submittedObs: false,
            loadingmotivo: false,
            motivos:[],
		}
	},	
	smartService: null,
	created() {
		this.smartService = new SmartService();
	},
	mounted() {
        this.loadMotivos();
	},
	methods: {
        getMovil(){
            return localStorage.movil_id;
        },

        getParada(){
            return localStorage.parada_id;
        },

        getMovilName(){
            return localStorage.movil_name;
        },

        getParadaName(){
            return localStorage.parada_name;
        },

        getIdTec(){
            return localStorage.tec_id;
        },

        getMultiplicador(){
            return localStorage.multiplicador;
        },

        async loadMotivos(){
            this.loadingmotivo = true;
            this.smartService.getMotivos().then(data => { 
            this.motivos = data;
            this.loadingmotivo = false;
            })
        },

        clearAll(){
            this.submittedMotivo = false;
            this.submittedObs = false;
            this.motivo=null;
            this.cantidad = 1;
            this.observacion = null;
        },

        entregar(){
            this.registrarExcepcion();
        },

        async registrarExcepcion() {
			this.submittedMotivo = true;
            this.submittedObs = true;
			if (this.motivo && this.cantidad && (this.observacion && this.observacion.length < 150)) {
                this.wait = true;
                this.loading = true;
                this.smartService.registrarRetiroEx(Number(this.getMovil()),Number(this.getParada()),this.motivo,this.cantidad,this.observacion,Number(this.getIdTec())).then(data => {
                    let msg = data;
                    this.wait = false;
                    this.loading = false;
                    if (msg != null){
                        if (msg.includes("ERROR")){
                            msg = msg.replace("ERROR","");
                            this.$toast.add({severity:'error', summary: 'Error', detail: msg, life: 3000});
                        }
                        else if (msg.includes("WARN")){
                            msg = msg.replace("WARN","");
                            this.$toast.add({severity:'warn', summary: 'Atención', detail: msg, life: 3000});
                        }
                        else{
                            this.$toast.add({severity:'success', summary: 'Registro exitoso', detail:msg, life: 3000});    
                        }
                    }
                    else{
                        this.$toast.add({severity:'error', summary: 'La entrega no fue registrada', detail: 'Ha ocurrido un error al comunicarse con el servidor. Cierre sesión, vuelva a ingresar e intentelo nuevamente.', life: 5000});
                    }
                    //Limpio el form
                    this.clearAll();
                });
			}
		},
		
	},
}
</script>

<style scoped lang="scss">
	.overview-detail {
        text-align: left;
        margin-top: 2rem;

        .p-col-6 {
            padding: .5rem;
        }
    }
</style>